import React from "react";
import TextInput, { TextInputProps } from "./TextInput";
import clsx from "clsx";

type SearchTextFieldProps = {} & TextInputProps;

export default function SearchTextField(props: SearchTextFieldProps) {
    const { leftIcon, inputContainerClassname, inputClassName, ...rest } = props;
    return (
        <TextInput
            type={"text"}
            inputClassName={clsx(
                "!h-[38px] !min-w-[150px] !w-[100%] pl-[0px] !bg-white text-sm !mb-0",
                inputClassName
            )}
            leftIcon={
                leftIcon || (
                    <i className="ri-search-line before:content-['\f0d1] text-slate-400 mt-[2px]"></i>
                )
            }
            widthClass="!ml-[2px]"
            inputContainerClassname={clsx(
                "!rounded-[4px]  max-sm:!w-full !pl-[40px] !h-[40px] !bg-white !border !border-n-20",
                inputContainerClassname
            )}
            {...rest}
        />
    );
}
